import { render, staticRenderFns } from "./EditMateria.vue?vue&type=template&id=e46bc0f2&"
import script from "./EditMateria.vue?vue&type=script&lang=js&"
export * from "./EditMateria.vue?vue&type=script&lang=js&"
import style0 from "./EditMateria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports